import { MPlayerState } from '../store.types';
import { playerDataSelector } from './playerData.selector';

const getRecirculationVideoData = playerDataSelector.recirculationVideoData;

export const recirculationVideoDataSelector = {
  currentScene(state: MPlayerState): number {
    return getRecirculationVideoData(state).currentScene;
  },
  startOfCurrentScene(state: MPlayerState): number {
    return getRecirculationVideoData(state).startOfCurrentScene;
  },
  endOfCurrentScene(state: MPlayerState): number {
    return getRecirculationVideoData(state).endOfCurrentScene;
  },
  selectedScene(state: MPlayerState): number {
    return getRecirculationVideoData(state).selectedScene;
  },
};
